import axios from "axios";
import { config } from "../config";
// import mockSnapshot from "../__mocks__/mockSnapshot";

export const  fetchSnapshot = async ({nodeLab, address} : {nodeLab: string, address: string}) => {
    const { data } =  await axios.get(
        `${config.host}:${nodeLab}/snapshot/safe?publickey=${address}&env=${nodeLab === "9093"? "main" : "test"}`
    );
    // const  data  =  JSON.parse(JSON.stringify(mockSnapshot));
    return data;
}

export const  systemHealth = async ({nodeLab} : {nodeLab: string}) => {
    const { data } =  await axios.get(
        `${config.host}:${nodeLab}/api/mpc/status`
      );
    return data;
}

export const  fetchOrderBook = async ({nodeLab, pair, dexAddress} : {nodeLab: string, dexAddress: string, pair: string}) => {
    const { data } =  await axios.get(
        `${config.host}:${nodeLab}/dex/${dexAddress}/pair/${pair}`
      );
    return data;
}

export const  fetchDexAccount = async ({nodeLab, accountID, dexAddress} : {nodeLab: string, dexAddress: string, accountID: string}) => {
    const { data } =  await axios.get(
        `${config.host}:${nodeLab}/dex/${dexAddress}/${accountID}`
      );
    return data;
}

